import { useSiteContent } from '@/hooks/useSiteContent';
import { useTranslation } from 'react-i18next';
import ContentState from '@/components/feature/ContentState';

interface AboutStat {
  value: string;
  label: string;
  icon: string;
}

export default function StatsSection() {
  const { data, loading, error, refresh } = useSiteContent<AboutStat[]>('about_stats');
  const { t } = useTranslation();

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-primary-500 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
            {t('about.statsTitle')}
          </h2>
          <p className="text-white/70 text-sm md:text-base mt-3 max-w-lg mx-auto">
            {t('about.statsSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {data.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                <i className={`${stat.icon} text-white text-xl`} />
              </div>
              <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-1">
                {stat.value}
              </p>
              <p className="text-white/70 text-sm font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}